import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/pro-light-svg-icons/faMapMarkerAlt';

import React, { useMemo, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import Global from '../../../../store/global-selectors';
import { useModal } from '../../../../hooks/use-modal';
import { NotificationService, NOTIFICATION_TYPE_SUCCESS } from 'ui-components/services/notification-service';
import { AccessibleEmoji } from 'ui-components/components/accessible-emoji';

import OnboardingStep from '../../steps';
import ConnectedList from '../connected-list';
import ShipFromModal from '../../../../ship-from/modals/';
import { trackShipFromConfigStart } from '../../../../ship-from/tracking-events';

import messages from './messages';

const ShipFromStep = () => {
  const sellerShipFroms = useSelector(Global.selectSellerShipFroms);
  const { open, close, isOpen } = useModal();

  const connectedShipFromsData = useMemo(() => {
    return sellerShipFroms.map((location) => {
      const { originAddress } = location;
      return {
        name: location.name,
        id: location.shipFromId,
        logo: <FontAwesomeIcon icon={faMapMarkerAlt} />,
        connectedMessage: (
          <FormattedMessage
            {...messages.connected}
            values={{
              line1: originAddress.line1,
              city: originAddress.city,
              state: originAddress.state,
              postal: originAddress.postalCode,
            }}
          />
        ),
        createdTime: new Date(location.createDateUtc).getTime(),
      };
    });
  }, [sellerShipFroms]);

  const onSuccess = useCallback(() => {
    close();
    NotificationService.showNotification({
      notificationType: NOTIFICATION_TYPE_SUCCESS,
      title: <FormattedMessage {...messages.saveSuccessMessage} />,
      content: '',
      duration: 10000,
    });
  }, [close]);

  const onClick = useCallback(() => {
    open();
    trackShipFromConfigStart('OnboardingStep');
  }, [open]);

  return (
    <>
      <OnboardingStep
        addAnotherMessage={<FormattedMessage {...messages.addAnotherMessage} />}
        buttonTitle={<FormattedMessage {...messages.addMessage} />}
        connectedList={<ConnectedList items={connectedShipFromsData} />}
        description={<FormattedMessage {...messages.description} />}
        isComplete={connectedShipFromsData.length > 0}
        onClick={onClick}
        stepTitle={<FormattedMessage {...messages.title} values={{ emoji: <AccessibleEmoji emoji='📍' emojiName='pin' /> }} />}
      />
      {isOpen && <ShipFromModal onClose={close} onSuccess={onSuccess} />}
    </>
  );
};

export default ShipFromStep;
